import { useContext, useMemo } from 'react';
import type { DrishtiPoolParams } from '../services/drishtiAuthTypes';
import { AppConfigContext } from './appConfigContext';

interface DrishtiRuntimeConfig {
    readonly drishti_cognito_config?: { readonly user_pool_id?: unknown; readonly client_id?: unknown };
}

const isNonEmptyString = (value: unknown): value is string => typeof value === 'string' && value.length > 0;

export const useDrishtiPool = (): DrishtiPoolParams | undefined => {
    const { config } = useContext(AppConfigContext);
    const { drishti_cognito_config: drishtiCognitoConfig } = (config ?? {}) as DrishtiRuntimeConfig;
    const userPoolId = drishtiCognitoConfig?.user_pool_id;
    const clientId = drishtiCognitoConfig?.client_id;
    return useMemo(
        () => (isNonEmptyString(userPoolId) && isNonEmptyString(clientId) ? { userPoolId, clientId } : undefined),
        [userPoolId, clientId],
    );
};
